import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const { user, login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await login(username, password);
      if (res.user) {
        localStorage.setItem("user", JSON.stringify({ username: res.user.username }));
        navigate(res.user?.role === "admin" ? "/admin" : "/dashboard");
      }
    } catch (err) {
      console.error("Erreur de connexion :", err);
      setError("Identifiants incorrects. Veuillez réessayer.");
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-4"
      style={{
        backgroundImage: "url('/images/login-bg.jpg')",
      }}
    >
      <div className="bg-black bg-opacity-70 p-8 rounded-lg shadow-2xl w-full max-w-md animate-fade-in">
        <div className="flex justify-center mb-6">
          <img
            src="/images/logo-infinity.png"
            alt="Infinity Game"
            className="w-40 md:w-48 drop-shadow-xl"
          />
        </div>

        <h1 className="text-2xl md:text-3xl text-center font-bold text-white mb-4">
          Connexion
        </h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Nom d'utilisateur"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2 bg-[#1f1f1f] text-white rounded-md border border-gray-700 focus:ring-2 focus:ring-blue-500 outline-none"
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 bg-[#1f1f1f] text-white rounded-md border border-gray-700 focus:ring-2 focus:ring-blue-500 outline-none"
          />

          {error && (
            <p className="text-center text-sm text-red-400">{error}</p>
          )}

          <button
            type="submit"
            className="w-full py-2 text-white font-semibold bg-gradient-to-r from-blue-600 to-blue-400 rounded hover:scale-105 transition transform"
          >
            Se connecter
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
